import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import Select, { components } from 'react-select';
import 'react-phone-input-2/lib/style.css';
import { useClientInformationContext } from '../../../Context/ClientInformation';

const Checkbox = ({ children, ...props }) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => null}
      style={{ marginRight: 10 }}
    />
    {children}
   </components.Option>
);

function ContactInformation({ formData, handleChange, invalidFields,errorMessage,selectedCustomerTypes, setSelectedCustomerTypes,selectedCategories, setSelectedCategories, phone, setPhone,isEmailEnabled,salesReps}) {
  const { customerTypeData, categoryData } = useClientInformationContext();
  const [emailError, setEmailError] = useState('');
  const [customerTypeError, setCustomerTypeError] = useState('');
  const [categoryError, setCategoryError] = useState('');

  useEffect(() => {
    handleChange({
      target: {
        name: 'phone',
        value: phone,
        type: 'text',
      },
    });
  }, [phone]);

     // Initial validation check for the Customer Type
  // useEffect(() => {
   
  //   if (selectedCustomerTypes.length === 0 ) {
  //     setCustomerTypeError('This field is required.');
  //   }
  // },[ selectedCustomerTypes]);

  const handleCustomerTypeChange = (selectedOptions) => {
    if (
      selectedOptions &&
      selectedOptions.some((option) => option.value === "selectAll")
    ) {
      if (selectedOptions.length === customerTypeOptions.length) {
        // Unselect all options
        setSelectedCustomerTypes([]);
        handleChange({
          target: {
            name: "customerType",
            value: [],
            type: "select-multiple",
          },
        });
        setCustomerTypeError("This field is required.");
      } else {
        // Select all options
        const allOptions = customerTypeOptions.filter(
          (option) => option.value !== "selectAll"
        );
        setSelectedCustomerTypes(allOptions);
        handleChange({
          target: {
            name: "customerType",
            value: allOptions.map((option) => option.value),
            type: "select-multiple",
          },
        });
        setCustomerTypeError("");
      }
    } else {
      // Handle normal selection
      setSelectedCustomerTypes(selectedOptions);
      const customerTypeValues = selectedOptions.map((option) => option.value);
      handleChange({
        target: {
          name: "customerType",
          value: customerTypeValues,
          type: "select-multiple",
        },
      });
      if (customerTypeValues.length === 0) {
        setCustomerTypeError("");
      } else {
        setCustomerTypeError("");
      }
    }
  };
 
  // useEffect(() => {
    
  //   if (selectedCategories.length === 0 ) {
  //     setCategoryError('This field is required.');
  //   }
  // },[ selectedCategories]);
  console.log("customerTypeError :",customerTypeError);

  const handleCategoryChange = (selectedOptions) => {
    const selectAllOption = selectedOptions.find(option => option.value === 'selectAll');
   
    if (selectAllOption) {
      // If all options are selected (including "Select All"), unselect all
      if (selectedOptions.length === categoryOptions.length) {
        setSelectedCategories([]);
        handleChange({
          target: {
            name: 'businessCategory',
            value: [],
            type: 'select-multiple',
          },
        });
        setCategoryError('This field is required.');
      } else {
        // Select all options except "Select All"
        const allOptions = categoryOptions.filter(option => option.value !== 'selectAll');
        setSelectedCategories(allOptions);
        handleChange({
          target: {
            name: 'businessCategory',
            value: allOptions.map(option => option.value),
            type: 'select-multiple',
          },
        });
        setCategoryError('');
      }
    } else {
      // Handle normal selection
      setSelectedCategories(selectedOptions);
      const categoryValues = selectedOptions.map(option => option.value);
      handleChange({
        target: {
          name: 'businessCategory',
          value: categoryValues,
          type: 'select-multiple',
        },
      });
      if (categoryValues.length === 0) {
        setCategoryError('');
      } else {
        setCategoryError('');
      }
    }
  };
   const validateEmail = (email) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    return emailPattern.test(email);
  };
 
  const handleEmailChange = (e) => {
    const { value } = e.target;
    if (!validateEmail(value)) {
      setEmailError('Invalid email address');
    } else {
      setEmailError('');
    }
    handleChange(e);
  };
 
  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: '40px',  
      overflowY: 'auto',
      borderColor: 'gray',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'gray',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#FFDFD6' : state.isFocused ? '#FFF6F6' : null,
      color: state.isSelected ? 'black' : 'black',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#FFDFD6',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'black',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: 'black',
      ':hover': {
        backgroundColor: 'red',
        color: 'white',
      },
    }),
  };
  const sortOptionsAlphabetically = (options) => {
    return options.sort((a, b) => a.label.localeCompare(b.label));
  };
 
  const sortedCustomerTypeData = sortOptionsAlphabetically(customerTypeData);
  const sortedcategoryData = sortOptionsAlphabetically(categoryData);
 
  const customerTypeOptions = [{ label: 'Select All', value: 'selectAll' }, ...sortedCustomerTypeData];
  const categoryOptions = [{ label: 'Select All', value: 'selectAll' }, ...sortedcategoryData];
 
 
  return (
    <div className="client-info-container">
      <div className="sub-container">
        <h3>Contact Information</h3>
        <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className='flex gap-0.5'>First Name<span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('contactFirstName') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}
            </label>
            <input
              // className={`input ${invalidFields.includes('contactFirstName') ? 'invalid' : ''}`}
              className="input"
              type="text"
              pattern="[A-Za-z]*"
              name="contactFirstName"
              value={formData.contactFirstName}
              onChange={handleChange}
              placeholder="---"
              required
            />
          </div>
          <div className="column">
            <label className='flex gap-0.5'>Last Name<span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('contactLastName') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}</label>
            <input
            //  className={`input ${invalidFields.includes('contactLastName') ? 'invalid' : ''}`}
              className="input"
              type="text"
              pattern="[A-Za-z]*"
              name="contactLastName"
              value={formData.contactLastName}
              onChange={handleChange}
              placeholder="---"
              required
            />
          </div>
        </div>
 
        <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className='flex gap-0.5'>Email Address <span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('email') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}
            </label>
            <input
                // className={`input ${invalidFields.includes('email') ? 'invalid' : ''}`}
              className="input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleEmailChange}
              placeholder="---"
              disabled={!isEmailEnabled}

            />
            {emailError && <span className="error">{emailError}</span>}
          </div>
          <div className="column">
            <label className='flex gap-0.5'>Phone No. <span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('phone') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}</label>
            <PhoneInput
              //  className={`number ${invalidFields.includes('phone') ? 'invalid' : ''}`}
               name ="phone"
              className="number"
              country={'us'}
              value={phone}
              enableSearch={true}
              onChange={(phone) => setPhone(phone)}
              required
            />
          </div>
        </div>
         <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className='flex gap-0.5'>Where did you hear about us ?
            <span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('hearAboutUs') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}
            </label>
            {/* <input
              // className={`input ${invalidFields.includes('hearAboutUs') ? 'invalid' : ''}`}
              className="input"
              type="text"
              name="hearAboutUs"
              value={formData.hearAboutUs}
              onChange={handleChange}
              placeholder="---"
              required
            /> */}
             <select
              className={`input ${
                invalidFields.includes("hearAboutUs") ? "invalid" : ""
              }`}
              name="hearAboutUs"
              value={formData.hearAboutUs}
              onChange={handleChange}
              required
            >
              <option value="" >
                --Select--
              </option>
              <option value="Trade Show">Trade Show</option>
              <option value="Social Media">Social Media</option>
              <option value="Internet">Internet</option>
              <option value="Friends">Friends</option>
              <option value="Online Advertisement ">Online Advertisement </option>
              <option value="Facebook">Facebook</option>
              <option value="Twitter">Twitter</option>
              <option value="Linked In">Linked In</option>
              <option value=" Wholesale Central"> Wholesale Central</option>
            </select>
          </div>
          <div className="column">
          </div>
        </div>
      </div>
 

      <div className="sub-container">
        <h3>Company Information</h3>
         <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
          <label className='flex gap-0.5'>Customer Type <span className='text-red-700 font-semibold text-md'>*</span>
      {invalidFields.includes('customerType') && (
        <p className='text-red-700 font-semibold text-md'>This field is required.</p>
      )}
       {customerTypeError && (
                <p className='text-red-700 font-semibold text-md'>{customerTypeError}</p>
              )}
      </label>
      <Select
        //className={`customerType ${invalidFields.includes('customerType') ? 'invalid' : ''}`}
        className="custom-select"
        name="customerType"
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option: Checkbox }}
        onChange={handleCustomerTypeChange}
        allowSelectAll={true}
        value={selectedCustomerTypes}
        options={customerTypeOptions}
        styles={customStyles}
        placeholder="---Select---"
      />
          </div>
          <div className="column">
            <label className="flex gap-0.5">Select the category your business specializes in <span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('businessCategory') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}
             {categoryError && (
                <p className='text-red-700 font-semibold text-md'>{categoryError}</p>
              )}
            </label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: Checkbox }}
              options={categoryOptions}
              value={selectedCategories}
              onChange={handleCategoryChange}
              placeholder="---Select---"
              styles={customStyles}
            />
          </div>
        </div>
 
         <div className="input-field-row nycfix-input-row">
          <div className="column nycfix-field">
            <label className='flex gap-0.5'>Sales Rep who reached out to you <span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('salesRep') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}
            </label>
                      <select
            name="salesRep"
            className={`selectStyle ${invalidFields.includes('salesRep') ? 'invalid' : ''}`}
            value={formData.salesRep === sessionStorage.getItem('none_of_above_user') && formData.salesRepLabel === "None of the Above" ? "none_of_the_above" : formData.salesRep}
            onChange={handleChange}
            required
          >
            <option value="">--Select--</option>
            {salesReps.map(rep => (
              <option key={rep.value} value={rep.value}>
                {rep.label}
              </option>
            ))}
            </select>
          </div>
 
          <div className="column">
            <label className='flex gap-0.5'>Company Name <span className='text-red-700 font-semibold text-md'>*</span>
            {invalidFields.includes('companyName') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
            )}</label>
            <input
              // className={`input ${invalidFields.includes('companyName') ? 'invalid' : ''}`}
              className="input"
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              placeholder="---"
              required
            /> 
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default ContactInformation;